import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CCreateEntreprise } from '@core/models/entreprise';
import { contactintrouvable, emailSended, serverError } from '@core/models/messages';
import { ContactService } from '@core/services/contact/contact.service';
import { LocalStorageService } from '@core/services/local-storage.service';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-contact-esn',
  templateUrl: './contact-esn.component.html',
  styleUrls: ['./contact-esn.component.css'],
})
export class ContactEsnComponent {
  contactEsnForm!: FormGroup;
  currentUser: any;
  id: any;
  filtered: any;
  submitted = false;

  types = [
    { value: 'Technique', id: '1' },
    { value: 'Service client', id: '2' },
    { value: 'Réclamation', id: '3' },
  ];

  selected: any = this.types[0];
  file: any;
  idResponsable: any;
  listContactNames: any;
  spinner: any;

  constructor(
    private contactService: ContactService,
    private localStorageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute
  ) {
    this.currentUser = new CCreateEntreprise();
  }
  toolbarOptions = [
    ['bold', 'italic', 'underline'], // toggled buttons
    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }], // outdent/indent
    ['clean'], // remove formatting button
  ];

  ngOnInit() {
    this.currentUser = this.localStorageService.getData('dataUser');
    // this.id = JSON.parse(this.currentUser).id
    this.getId();
    this.contactEsnFormGroup();
    this.getContactNames()
  }

  /* get id esn */
  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.idResponsable = params.params['idResponsable'];
      },
    });
  }

  contactEsnFormGroup(data?: any) {
    this.contactEsnForm = this.formBuilder.group({
      mailing_id: [data ? data.mailing_id : null],
      object: ['', [Validators.required, Validators.maxLength(100)]],
      subject: ['', Validators.required],
      user_id: [''],
      esn_id: this.idResponsable,

      file: [''],
    });
  }
  fileName: string = '';
  resetFile() {
    const inputFile = document.getElementById('cv_file') as HTMLInputElement;
    if (inputFile) {
      inputFile.value = '';
    }
    this.file = null;
    this.fileName = '';
  }
  onFileChange(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files[0]) {
      const file = fileInput.files[0];
      this.file = file;
      this.contactEsnForm.get('file')?.setValue(this.file);
    }
  }

  contactEsn() {
    this.submitted = true;
    console.log(
      '%ccontact-esn.component.ts line:64 object',
      'color: #007acc;',
      this.contactEsnForm.value
    );
    if (this.contactEsnForm.invalid) {
      return;
    } else {
      this.contactEsnForm.get('user_id')?.setValue(this.id);
      console.log('contactForm', this.contactEsnForm.value);

      const formData = new FormData();
      formData.append(
        'mailing_id',
        this.contactEsnForm.get('mailing_id')?.value
      );
      formData.append('object', this.contactEsnForm.get('object')?.value);
      formData.append('subject', this.contactEsnForm.get('subject')?.value);
      formData.append('user_id', this.id);
      formData.append('esn_id', this.contactEsnForm.get('esn_id')?.value);
      formData.append('file', this.contactEsnForm.get('file')?.value);

      const formDataObject: { [key: string]: any } = {};
      formData.forEach((value, key) => {
        formDataObject[key] = value;
      });

      console.log('formDataObject++', formDataObject);

      this.contactService
        .contactEsn(formData)
        .pipe()
        .subscribe({
          next: (res) => {
            this.toastrService.success(emailSended);
            this.onReset();
          },
          error: (err) => {
            console.log('error', err);
            if (err?.error) {
              this.toastrService.error(serverError);
            }
          },
        });
    }
  }

  get f() {
    return this.contactEsnForm.controls;
  }

  onSelectChange(event: any) {
    console.log('Selected:', event);
  }

  onReset() {
    this.submitted = false;
    this.contactEsnForm.reset({
      type: '',
      esn_id: this.idResponsable,
      user_id: this.id,
    });
    this.contactEsnForm.get('file')?.setValue('');
    this.contactEsnForm.get('type')?.setValue('');
  }
  getContactNames() {
 
    this.contactService.getContactNamesByCandidat(this.idResponsable)
      .pipe(finalize(() => this.spinner.hide())
      )
      .subscribe(
        (res: any) => {
          this.listContactNames = res?.data;
          console.log('listContactNames', this.listContactNames);
        },
        (error) => {
          console.error('Error fetching listOfMonths:', error);
        }
      );
  }
}
